import React from 'react'

interface GlobalScrollEffectsProps {
  children: React.ReactNode
}

export default function GlobalScrollEffects({ children }: GlobalScrollEffectsProps) {
  return <>{children}</>
}
